module.exports = __webpack_public_path__ + "img/icon-cup.faa0fbc0.svg";